import React, { useState } from "react";
import Layout from "../components/Layout";
import { API_BASE_URL } from "../constants/api";

const SendMessagePage = () => {
  const [mobile, setMobile] = useState("");
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!mobile || !text) { alert("Please fill all fields"); return; }
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/api/sms/submit`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobileNo: mobile.trim(), text }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Error sending SMS");
      alert("Request ID: " + data.requestId);
      setMobile("");
      setText("");
    } catch (error) {
      console.error(error);
      alert(error.message || "Error sending SMS");
    } finally {
      setLoading(false);
    }
  };

  const fieldStyle = { backgroundColor: "#111111", border: "1px solid #2a2a2a", color: "#ffffff" };

  return (
    <Layout title="Send SMS">
      <div className="max-w-lg">
        <p className="mb-6" style={{ color: "#888888" }}>Send an SMS message to a mobile number.</p>

        <div className="rounded-2xl p-8" style={{ backgroundColor: "#1c1c1c", border: "1px solid #2a2a2a" }}>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1" style={{ color: "#cccccc" }}>Mobile Number</label>
              <input
                type="text"
                placeholder="e.g. 9876543210"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                className="w-full px-4 py-2.5 rounded-xl text-sm placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-yellow-400 transition-colors"
                style={fieldStyle}
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1" style={{ color: "#cccccc" }}>Message</label>
              <select
                value={text}
                onChange={(e) => setText(e.target.value)}
                className="w-full px-4 py-2.5 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400 transition-colors"
                style={fieldStyle}
              >
                <option value="">Select a message</option>
                <option value="Test SMS">Test SMS</option>
                {/*<option value="Service SMS">Service SMS</option>
                <option value="Recharge successful">Recharge successful</option>*/}
              </select>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 text-sm font-semibold rounded-xl transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
              style={{ backgroundColor: "#ffc20e", color: "#000000" }}
              onMouseEnter={(e) => { if (!loading) e.currentTarget.style.backgroundColor = "#e6ae00"; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#ffc20e"; }}
            >
              {loading ? "Sending..." : "Send SMS"}
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default SendMessagePage;
